import React, { useEffect, useState, useCallback } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { API_BASE_URL } from "../config";
import { Link } from "react-router-dom";

const Customiseproduct = () => {
  const [user, setUser] = useState(null);
  const [categories, setCategories] = useState([]);
  const [metals, setMetals] = useState([]);
  const [metalPurityTypes, setMetalPurityTypes] = useState([]);
  const [diamondQualities, setDiamondQualities] = useState([]);
  const [diamondColours, setdiamondcolour] = useState([]);
  const [diamondType, setdiamondType] = useState([]);
  const [Size, setSize] = useState([]);
  const [file, setFile] = useState([]);
  const [file1, setFile1] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
const [requirements, setRequirements] = useState([""]);

  const [formData, setFormData] = useState({sizeid: ""});


  const fetchCategories = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetCustomisedCategory`);
      const result = await response.json();
      setCategories(result.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }, []);

  const fetchMetals = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetMetal`);
      const result = await response.json();
      setMetals(result.data || []);
    } catch (error) {
      console.error("Error fetching metals:", error);
    }
  }, []);


  const fetchMetalPurityTypes = useCallback(async (metalId) => {
    if (!metalId) {
      setMetalPurityTypes([]);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetMetalCaret?metalid=${metalId}`);
      const result = await response.json();
      setMetalPurityTypes(result.data || []);
    } catch (error) {
      console.error("Error fetching metal purity types:", error);
    }
  }, []);

  const fetchDiamondType = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetDiamond`);
      const result = await response.json();
      setdiamondType(result.data || []);
    } catch (error) {
      console.error("Error fetching diamond qualities:", error);
    }
  }, []);

  const fetchDiamondQualities = useCallback(async (diamondid) => {
    if (!diamondid) {
      setDiamondQualities([]);
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetClaritys?Diamondid=${diamondid}`);
      const result = await response.json();
      setDiamondQualities(result.data || []);
    } catch (error) {
      console.error("Error fetching diamond qualities:", error);
    }
  }, []);

  const fetchDiamondcolour = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetDiamondColours`);
      const result = await response.json();
      setdiamondcolour(result.data || []);
    } catch (error) {
      console.error("Error fetching diamond qualities:", error);
    }
  }, []);


  const fetchsize = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/CustomisedMaster/GetSizeSubCategory`);
      const result = await response.json();
      setSize(result.data || []);
    } catch (error) {
      console.error("Error fetching stones color :", error);
    }
  }, []);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
    fetchCategories();
    fetchsize();
    fetchMetals();
    fetchDiamondQualities();
    fetchDiamondType();
    fetchDiamondcolour();

  }, [fetchCategories, fetchMetals, fetchDiamondQualities, fetchsize, fetchDiamondType,fetchDiamondcolour]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "categoryName") {
      const selectedCategory = categories.find((cat) => cat.name === value);
      setFormData({
        ...formData,
        categoryName: value,
        categoryId: selectedCategory ? selectedCategory.id : "", // Store ID
       sizeid:"",
      });
    }
    if (name === "metalId") {
      fetchMetalPurityTypes(value);
    }

    if (name === "diamondid") {
      fetchDiamondQualities(value);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));


  };
  const filteredSize = Size.filter((item) => {
    if (formData.categoryName === "Rings") return item.sizeAU;
    if (formData.categoryName === "Bracelets") return item.displayName;
    if (formData.categoryName === "Necklaces") return item.displayName;
    return false;
  });
  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const inputId = event.target.id;

    let allowedExtensions = [];

    if (inputId === "UploadImage") {
      allowedExtensions = [".jpg", ".jpeg", ".png"];
    } else if (inputId === "UploadImage1") {
      allowedExtensions = [".jcd", ".3dm", ".stl", ".pdf"];
    }

    const invalidFiles = selectedFiles.filter(file => {
      const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
      return !allowedExtensions.includes(ext);
    });

    if (invalidFiles.length > 0) {
      alert("Invalid file type(s) detected. Please upload only: " + allowedExtensions.join(", ").toUpperCase());
      event.target.value = "";
      return;
    }


    if (inputId === "UploadImage") {
      setFile(selectedFiles);
    } else if (inputId === "UploadImage1") {
      setFile1(selectedFiles);
    }
  };



  const handleSubmit = async () => {
    setIsSubmitting(true);
    if (!formData.categoryName) {
      alert("Please select a Category.");
      setIsSubmitting(false);
      return;
    }
    if (["Rings", "Bracelets", "Necklaces"].includes(formData.categoryName)) {
      if (formData.sizeid === "Select Size" || formData.sizeid === "") {
        alert("Please select a valid size.");
        setIsSubmitting(false);
        return;
      }
    }
    
 
 
   
    if (!formData.metalId) {
      alert("Please Select Metal");
      setIsSubmitting(false);
      return;
    }
    if (!formData.metalCaretId) {
      alert("Please Select Purity Type");
      setIsSubmitting(false);
      return;
    }
    if (!formData.deliveryDate) {
      alert("Please Select Delivery Date");
      setIsSubmitting(false);
      return;
    }

    if (!file || file.length === 0) {
      alert("Please upload at least one image file.");
      setIsSubmitting(false);
      return;
    }

const CountryName="AU";
    const productData = {
      Id: editingProductId || null,
      ...formData,
      CategoryId: formData.categoryId,
      MetalId: parseInt(formData.metalId || 101),
      MetalCaretId: parseInt(formData.metalCaretId || 101),
      QualityId: parseInt(formData.diamondQuality || 101),
      DiamondId: parseInt(formData.diamondid || 101),
      SizeId: parseInt(formData.sizeid || 101),
      Carat: formData.diamondCarat || 0,
      StoneColor: "",//formData.colorStone,
      Finding: formData.finding,
      Engraving: formData.engraving,
      DeliveryDate: formData.deliveryDate,
      ProductDescription: formData.productDescription,
      CreatedBy: "Customer",
      Status: "New Entry",
      Stage: "Pending",
      UserID: user?.companyId,
      ReferenceNo: formData.ReferenceNo,
      RefcustomerName: formData.RefCustomerName,
      DiamondColourid: parseInt(formData.diamondColourid || 101),
      StaffName: formData.StaffName,
      Requirements: requirements.filter(r => r.trim() !== ""),
      Country:"AU",
      ActionType: editingProductId ? "UPDATE" : "INSERT",
    };


    const formPayload = new FormData();
    formPayload.append("modelJson", JSON.stringify(productData));
    if (file && file.length > 0) {
      file.forEach((f) => formPayload.append("UploadImage", f)); // Files for Attachment
    }

    if (file1 && file1.length > 0) {
      file1.forEach((f) => formPayload.append("UploadImage1", f)); // Files for PartnerAttachment
    }


    try {
      const response = await fetch(`${API_BASE_URL}/Customised/InsertProductCustomizationBYPartener`, {
        method: "POST",
        body: formPayload,
      });

      // Check if response is OK (status 200-299)
      if (!response.ok) {
        const errorText = await response.text(); // Read error message
        throw new Error(`Server Error: ${errorText}`);
      }

      const result = await response.json();
      alert(result.message || "Product saved successfully!");
      clearForm();
      window.location.reload();
    } catch (error) {
      console.error("Error saving product:", error);
      alert(error.message); // Show error message to user
    }
    finally {
      setIsSubmitting(false);
    }
  };



  const clearForm = () => {
    setEditingProductId(null);
    setFormData({
      ReferenceNo: "", RefCustomerName: "", categoryName: "", categoryId: "", metalId: "",
      metalCaretId: "", diamondQuality: "", diamondid: "", diamondCaret: "", 
      finding: "", engraving: "", deliveryDate: "", qtyDiamond: "",
      diamondCarat: "", sizeid: "", productDescription: "", diamondColourid: "", mounttype: "", StaffName: "",
    });
    setFile(null);
    setFile1(null);
  };
 const handleRequirementChange = (index, value) => {
  const newRequirements = [...requirements];
  newRequirements[index] = value;
  setRequirements(newRequirements);
};

const handleAddRequirement = () => {
  setRequirements([...requirements, ""]);
};

const handleRemoveRequirement = (index) => {
  const newRequirements = [...requirements];
  newRequirements.splice(index, 1);
  setRequirements(newRequirements);
};

  return (
    <>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />

          <div className="container mt-4">
            <div className="card">
              <div className="card-body">
                <h4> <Link to="/partnerdashboard" style={{ color: "black" }} className="btn btn-view"> <i className="fa fa-arrow-left" aria-hidden="true"></i></Link> {editingProductId ? "Update Product Customization" : "Create New Custom Order"}   </h4>
                <div className="row mt-3">
                  <div className="col-md-4">
                    <label>Staff Name</label>
                    <input type="text" id="StaffName" name="StaffName" className="form-control" value={formData.StaffName} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Order Reference</label>
                    <input type="text" id="ReferenceNo" name="ReferenceNo" className="form-control" value={formData.ReferenceNo} onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <label>Customer Name</label>
                    <input type="text" id="RefCustomerName" name="RefCustomerName" className="form-control" value={formData.RefCustomerName} onChange={handleChange} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span>Category</label>
                    <select className="form-control" name="categoryName" value={formData.categoryName} onChange={handleChange}>
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.name}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span>Select Size</label>
                    <select className="form-control" name="sizeid" value={formData.sizeid} onChange={handleChange}>
                      {
                        filteredSize.filter(item => item.category === formData.categoryName).length === 0 ? (
                          <>
                          <option value="NA">NA</option></>
                          
                        ) : (
                          <>
                            <option value="Select Size">Select Size</option>
                            {
                              filteredSize
                                .filter(item => item.category === formData.categoryName)
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {formData.categoryName === "Rings" ? item.sizeAU :
                                      formData.categoryName === "Bracelets" ? item.displayName :
                                        formData.categoryName === "Necklaces" ? item.displayName :
                                          ""}
                                  </option>
                                ))
                            }
                          </>
                        )
                      }
                    </select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span> Select Metal</label>
                    <select className="form-control" name="metalId" value={formData.metalId} onChange={handleChange}>
                      <option value="">Select Metal</option>
                      {/* {metals.map((metal) => (
                        <option key={metal.id} value={metal.id}>{metal.metalname}</option>
                      ))} */}
                      {[...metals]
  .sort((a, b) => a.metalname.localeCompare(b.metalname))
  .map((metal) => (
    <option key={metal.id} value={metal.id}>
      {metal.metalname}
    </option>
))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label><span style={{ color: "red" }}>*</span> Metal Purity Type</label>
                    {/* <select className="form-control" name="metalCaretId" value={formData.metalCaretId} onChange={handleChange}>
                      <option value="">Select Purity Type</option>
                      {metalPurityTypes.map((item) => (
                        <option key={item.id} value={item.id}>{item.displayname}</option>
                      ))}
                    </select> */}
                    <select
  className="form-control"
  name="metalCaretId"
  value={formData.metalCaretId}
  onChange={handleChange}
>
  <option value="">Select Purity Type</option>
  {[...metalPurityTypes]
    .sort((a, b) => {
      const numA = parseInt(a.displayname);
      const numB = parseInt(b.displayname);
      return numA - numB;
    })
    .map((item) => (
      <option key={item.id} value={item.id}>
        {item.displayname}
      </option>
    ))}
</select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-4">
                    <label>Diamond Type</label>
                    <select className="form-control" name="diamondid" value={formData.diamondid} onChange={handleChange}>
                      <option value={101}>Select Diamond Type</option>
                      {diamondType.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Diamond Clarity</label>
                    <select className="form-control" name="diamondQuality" value={formData.diamondQuality} onChange={handleChange}>
                      <option value={101}>Select Diamond Clarity</option>
                      {diamondQualities.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Diamond Colour</label>
                    <select className="form-control" name="diamondColourid" value={formData.diamondColourid} onChange={handleChange}>
                      <option value={101}>Select Diamond Colour</option>
                      {diamondColours.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                 
                  
                </div>
              </div>
              <div className="row mt-3">
                 <div className="col-md-3">
                    <label>Diamond Carat</label>
                    <input
  type="text"
  id="diamondCarat"
  name="diamondCarat"
  className="form-control"
  value={formData.diamondCarat}
  onChange={(e) => {
    let value = e.target.value;

    // Allow only numbers and at most one '.'
    value = value.replace(/[^0-9.]/g, '');      // Remove anything except digits and '.'
    const parts = value.split('.');
    if (parts.length > 2) {
      // If multiple '.', keep only first part and first '.'
      value = parts[0] + '.' + parts[1];
    }

    handleChange({ target: { name: e.target.name, value } });
  }}
/>
</div> 
                <div className="col-md-3">
                  <label htmlFor="finding">
                    Finding
                  </label>
                  <input className="form-control" type="text" name="finding" id="finding" value={formData.finding} onChange={handleChange} />
                </div>
                <div className="input-field col-md-3">
                  <label>Engraving</label>
                  <input className="form-control" type="text" name="engraving" value={formData.engraving} onChange={handleChange} />
                </div>
                <div className="input-field col-md-3">
                  <label><span style={{ color: "red" }}>*</span>Delivery Date</label>
                  <input
    className="form-control"
    type="date"
    name="deliveryDate"
    value={formData.deliveryDate}
    onChange={handleChange}
    min={new Date().toISOString().split("T")[0]}  // 👈 this line ensures no past dates
  />
                  {/* <input className="form-control" type="date" name="deliveryDate" value={formData.deliveryDate} onChange={handleChange} /> */}
                </div>
              </div>

               <br></br>
<div className="row mt-3">
 
  {requirements.map((req, index) => (
    <>
    <div key={index} className="d-flex align-items-center mb-2 col-md-10">
      
        <input
          type="text"
          className="form-control"
          value={req}
          onChange={(e) => handleRequirementChange(index, e.target.value)}
          placeholder={`Requirement ${index + 1}`}
        />
         <br></br>
      </div>
     
      <div className="col-md-2">
         
        {requirements.length > 1 && (
          <button
            type="button"
            className="btn-danger"
            onClick={() => handleRemoveRequirement(index)}
          >
            -
          </button>
        )}
      </div>
    </>
  ))}

  {/* Add button shown separately, after the loop */}
       <div className="d-flex justify-content-end">
   <button
      type="button"
      className="btn btn-success"
      onClick={handleAddRequirement}
    >
      + Add
    </button>
  </div>
</div>
              <div className="mt-3">
                <label>Customer Description</label>
                <ReactQuill theme="snow" value={formData.productDescription} onChange={(value) => setFormData((prev) => ({ ...prev, productDescription: value }))} style={{ height: "200px" }} />
              </div>
              <br></br><br></br>
              {/* File Upload */}
              <div className="row mt-3">
                <div className="col-md-6">
                  <label><span style={{ color: "red" }}>*</span>Upload Image (JPG / JPEG and PNG File only)</label>
                  <input type="file" id="UploadImage" className="form-control" onChange={handleFileChange} accept=".jpg, .jpeg, .png" multiple />
                </div>
                <div className="col-md-6">
                  <label>Upload Image (JCD / 3DM / STL / PDF File only)</label>
                  <input type="file" id="UploadImage1" className="form-control" onChange={handleFileChange} accept=".jcd, .3dm, .stl, .pdf" multiple />
                </div>
              </div>
              <br></br>
              {/* Buttons */}
              <div className="row mt-4">
                <div className="col-md-3">
                  <button className="btn btn-primary btn-block" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? "Submitting..." : editingProductId ? "Update" : "Save / Create New Product"}
                  </button>
                </div>
                <div className="col-md-3">
                  <button className="btn btn-dark btn-block" onClick={clearForm} disabled={isSubmitting}>
                    Clear
                  </button>
                </div>
              </div>
              <br></br>
            </div>
          </div>


          <Footer />
        </div>
      </div>
    </>
  );
};

export default Customiseproduct;
